function filterParams(options) {
  const params = {}
  for (const key in options) {
    const value = options[key]
    if (value) {
      params[key] = value
    }
  }
  return params
}

function filterConnectionParams(reqOptions) {
  const arr = reqOptions.connectionParams
  const params = {}
  for (const key in arr) {
    const value = arr[key].value
    if (value) {
      params[arr[key].param_id] = arr[key].value
    }
  }
  return params
}

export default (axios) => ({
  async createTournament(reqOptions) {
    const url = '/private-tournament/create/'
    let lobbyId, lobbyPass, lobbyUrl, teamTag
    reqOptions.connectionParams.find((el) => {
      if (el.param_id === 'lobby_id') {
        lobbyId = el.value
      } else if (el.param_id === 'lobby_pass') {
        lobbyPass = el.value
      } else if (el.param_id === 'lobby_url') {
        lobbyUrl = el.value
      } else if (el.param_id === 'team_tag') {
        teamTag = el.value
      }
    })

    const options = {
      title: reqOptions.title,
      game: reqOptions.game,
      max_prize_fund: reqOptions.prizeFund,
      ticket_price: reqOptions.ticketPrice,
      price_type: reqOptions.priceType,
      start_time: reqOptions.startTime,
      max_participants: reqOptions.maxParticipants,
      lobby_id: lobbyId,
      lobby_pass: lobbyPass,
      lobby_url: lobbyUrl,
      team_tag: teamTag,
      participants_type: reqOptions.activeMode
    }
    const params = filterParams(options)
    params.connection_params = filterConnectionParams(reqOptions)
    params.price_type = reqOptions.priceType === 0 ? 'green' : 'blue'
    params.membership_required = reqOptions.activeMembership === 0 ? 'free' : 'prem'
    return (await axios.put(url, params)).data.data
  },
  async getTournaments(reqOptions) {
    const url = '/tournaments/'
    const options = {
      game__id: reqOptions.gameId,
      game__title: reqOptions.gameTitle,
      game__platform: reqOptions.gamePlatform,
      page: reqOptions.page
    }
    const params = filterParams(options)
    return (await axios.get(url, {params})).data.data
  },
  async getTournament(id) {
    const url = `/tournaments/${id}/`
    return (await axios.get(url)).data.data
  },
  async getTournamentStage(id) {
    const url = `/tournament-stage/${id}/participants/`
    return (await axios.get(url)).data.data
  },
  async getConnectionParams(id) {
    const url = `/tournament-stage/${id}/connection_params`
    return (await axios.get(url)).data.data
  },
  async joinTournament(id) {
    const url = `/tournament-stage/${id}/participate/`
    return (await axios.post(url)).data.data
  },
  async setTournamentResult({stageId}, arr) {
    const url = `/tournament-stage/${stageId}/participant/set_result/bulk/`
    const data = {
      stage_results: arr
    }
    return (await axios.post(url, data)).data.data
  },
  async setTournamentResultCustom(stageId, arr) {
    const url = `/tournament-stage/${stageId}/set_stage_results`
    const data = {
      results: arr
    }
    return (await axios.post(url, data)).data.data
  },
  async getTournamentResultCustom(stageId) {
    const url = `/tournament-stage/${stageId}/set_stage_results`
    return (await axios.get(url)).data.data
  },
  async banPlayer(stageId, playerId) {
    const url = `/tournament-stage/${stageId}/participant/${playerId}/block/`
    return (await axios.post(url)).data.data
  }
})



// WEBPACK FOOTER //
// ./src/pkg/api/tournament.js